import React, { HTMLAttributes } from 'react';

import { Container } from '@uncinc/uncinc-react-kitchen-sink';
import type { ImmutableEntity } from '@uncinc/react-drupal-core/types';

import type { ParagraphLinkList as Type } from '../../../types/uncinc_profile/paragraphs';
import {
  LinkList,
} from '../../../components';

import './style.scss';

interface ParagraphLinkListProps extends React.HTMLProps<HTMLAttributes<HTMLDivElement>> {
  entity: ImmutableEntity<Type>;
}

const ParagraphLinkList: React.FC<ParagraphLinkListProps> = ({ entity }) => {
  const paragraph = entity.toJS();

  const linkListItems = paragraph.field_paragraphs;

  return (
    <div className="Paragraph ParagraphLinkList">
      <Container>
        <div className="row">
          <div className="col-12">
            <div className="ParagraphLinkList__wrapper">
              <div className="ParagraphLinkList__wrapper__mobile">
                <LinkList>
                  {linkListItems.map((item, i) => {
                    const itemTitle = item.entity.field_title?.[0]?.value;
                    const itemSubtitle = item.entity.field_label[0]?.value;
                    const itemLink = item.entity.field_link[0];
                    const itemLinkUrl = itemLink?.alias ?? itemLink?.uri;
                    const itemLinkTitle = itemLink.title;
                    const itemImage = item.entity.field_media_item;
                    const imageStyles = itemImage[0]?.styles;

                    const ratio: string = '3_4';

                    const itemImageStyles = ['xs', 'sm', 'md', 'xl'].map((sizes) => {
                      const style = `ratio_${ratio}_${sizes}`;
                      return `${imageStyles?.[style] || ''}`;
                    });

                    return (
                      <LinkList.Item
                        key={item.target_id}
                        title={itemTitle}
                        subtitle={itemSubtitle}
                        link={itemLinkUrl}
                        imageUrl={itemImageStyles}
                        labelLinkTitle={itemLinkTitle}
                      />
                    );
                  })}
                </LinkList>
              </div>
              <div className="ParagraphLinkList__wrapper__desktop">
                <LinkList>
                  {linkListItems.map((item, i) => {
                    const itemTitle = item.entity.field_title?.[0]?.value;
                    const itemSubtitle = item.entity.field_label[0]?.value;
                    const itemLink = item.entity.field_link[0];
                    const itemLinkUrl = itemLink?.alias ?? itemLink?.uri;
                    const itemLinkTitle = itemLink.title;
                    const itemImage = item.entity.field_media_item;
                    const imageStyles = itemImage[0]?.styles;

                    // 1st or 4th image are 4:3
                    // 2nd and 3rd are 3:4
                    let ratio: string = '3_4';
                    if ((i % 3 === 0)) {
                      ratio = '4_3';
                    }

                    const itemImageStyles = ['xs', 'sm', 'md', 'xl'].map((sizes) => {
                      const style = `ratio_${ratio}_${sizes}`;
                      return `${imageStyles?.[style] || ''}`;
                    });

                    return (
                      <LinkList.Item
                        key={item.target_id}
                        title={itemTitle}
                        subtitle={itemSubtitle}
                        link={itemLinkUrl}
                        imageUrl={itemImageStyles}
                        labelLinkTitle={itemLinkTitle}
                      />
                    );
                  })}
                </LinkList>
              </div>
            </div>
          </div>
        </div>
      </Container>
    </div>
  );
};

export default ParagraphLinkList;
